<template>
  <div v-if="revision">
    <page-header
      :header="revision.subject"
    >

      <router-link
        v-if="!newsletter.sentAt"
        :to="{
          name: 'newsletters.draft',
          params: {
            draftId: newsletter.draft,
          },
        }"
        class="ml-1 btn btn-primary "
      >
        Edit
      </router-link>
    </page-header>



    <div
      class="row mt-3"
    >
      <div class="col-12 col-md-3 pad-bottom-1 pr-0">
        <div class="h-100 p-3">
          <span style="color: #101820;font-size: 18px">Subject:</span>
          <div
            style="font-weight: 200; font-size: 16px;"
          >
            {{ newsletter.publishedRevision.subject }}
          </div>
        </div>
      </div>

      <div class="col-12 col-md-3 pad-bottom-1 pr-0">
        <div class="h-100 p-3">
          <span style="color: #101820; font-size: 18px;">From name:</span>
          <div
            style="font-weight: 200; font-size: 16px;"
          >
            {{ newsletter.publishedRevision.fromName }}
          </div>
        </div>
      </div>
      <div class="col-12 col-md-3 pad-bottom-1 pad-right-0">
        <div class="h-100 p-3">
          <span style="color: #101820; font-size: 18px;">From email:</span>
          <div
            style="font-weight: 200; font-size: 16px;"
          >
            {{ newsletter.publishedRevision.fromEmail }}
          </div>
        </div>
      </div>

      <div class="col-12 col-md-3 pad-bottom-1 pad-right-0">
        <div class="h-100 p-3">
          <span style="color: #101820; font-size: 18px;">
            <span v-if="newsletter.sentAt">Sent at:</span>
            <span v-else>Sending at:</span>
          </span>
          <div v-date="{ date: newsletter.sentAt ? newsletter.sentAt : newsletter.sendAt, isIso: true }" />
        </div>
      </div>
    </div>

    <div class="pt-3">
      <tabs ref="tabs">

        <tab
          name="Analytics"
          v-if="$login.canAnalytics()"
        >
          <analytics
            :data="newsletter"
          />
        </tab>
        <tab name="Preview">
          <div
            class="email-preview-content shadow my-5 mx-auto"
            style="width: 800px;"
          >
            <div

              v-if="isShadowDOMSupported"
              ref="shadowPreview"
            />
            <div
              v-else
              v-html="html"
            />
          </div>
        </tab>

        <tab
          name="Recipients"
        >
          <recipients
            class="mt-3"
            :newsletter="newsletter"
          />
        </tab>
      </tabs>
    </div>
  </div>
</template>

<script>
import gateway from '@/gateway'
import Tab from '@/components/Tab'
import Tabs from '@/components/Tabs'
import Date from '@/directives/date'
import Recipients from './Recipients'
import Analytics from './Analytics'

export default {
  components: {
    Tab,
    Analytics,
    Tabs,
    Recipients,
  },

  directives: {
    Date,
  },

  data () {
    return {
      newsletter: null,
      revision: null,
      html: null,
      isShadowDOMSupported: false,
    }
  },

  async mounted ( ) {
    this.isShadowDOMSupported = !!document.head.attachShadow
    const response = await gateway.get(`/newsletters/${this.$route.params.newsletterId}`)

    this.newsletter = response.data.data
    this.revision = this.newsletter.publishedRevision

    const {data} = await gateway.get(`/newsletters/previews/${this.$route.params.newsletterId}`)
    this.html = data.data.html


    this.$nextTick(() => {
      setTimeout(() => {
        if (this.isShadowDOMSupported) {
          const shadowRoot = this.$refs.shadowPreview.shadowRoot || this.$refs.shadowPreview.attachShadow({mode: 'open'})
          shadowRoot.innerHTML = this.html
        }
      }, 500)
    })
  },
}
</script>
